<template>
    <div class="container-fluid mt-4">
        <div class="container-fluid">
              <div class="row d-flex justify-content-between">
                <div class="col-4">
                  <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="100px"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50px"/></span><br>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
                </div>
                <div class="col-5">
                    <!-- <img class="img-rounded" src="@/assets/images/sick.png" height="50px" /><br> -->
                    <table v-for="item in patients" :key="item.id" class="table" density="compact" style="color:black">
                    <img class="img-rounded" :src="getPhotos(item.photo)" height="50px" />
                    <tr><td>Full Name </td><td> {{ item.name }}</td></tr>
                    <tr><td>Gender </td><td> {{ item.gender }} </td></tr>
                    <tr><td> Telephone </td><td> 0{{ item.telephone }} </td></tr>
                    <tr><td> Age </td><td> {{ getAge(item.date_of_birth) }}  </td></tr>
                    <tr><td> Address </td><td> {{ item.address }} </td></tr>
                  </table>
                </div>
              </div>
              </div>
          <h4 class="mt-2 text-center text-decoration-underline">Patient Profile</h4>
              
            <div class="container-fluid">
            <h4 class="mt-3" style="color:black">Patient Visits</h4>
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th></tr></thead>
                <tbody>
                <tr v-for="item in visits" :key="item.id">
              
                    <td>{{ item.service_category ? item.service_category.name : 'N/A' }}</td>

                    <!-- <td>{{ item.service_name && item.service_name.name ? item.service_name.name : (item.insurance_service_name && item.insurance_service_name.name ? item.insurance_service_name.name : '') }}</td> -->
                    <td>{{ item.insurance_service_name.name }}</td>

                    <td>{{ item.service_price }}</td>
                </tr>
                </tbody>
                </table>
            <!-- <h4 class="mt-3" style="color:black">Triage History</h4>
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Temperature</th><th>Weight</th><th>Height</th><th>Muac</th><th>Blood Pressure</th><th>Pulse</th></tr></thead>
                <tbody>
                    <tr v-for="item in triages" :key="item.id">
                        <td>{{ item.temperature }} ℃</td>
                        <td>{{ item.weight }} Kgs</td>
                        <td>{{ item.height }} cm</td>                                  
                        <td>{{ item.muac }} cm</td>                                  
                        <td>{{ item.bloodpressure }} mmHg</td>                                  
                        <td>{{ item.pulse }} b/min</td>                                 
                    </tr>
                </tbody>
                </table>
            <h4 class="mt-3" style="color:black">Appointments</h4>
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Person to See</th><th>Appointment Date</th><th>Appointment Time</th></tr></thead>
                <tbody>
                <tr v-for="item in appointments" :key="item.id">
                    <td>{{ item.staff.full_name }} </td>
                    <td>{{ item.appointment_date }}</td>
                    <td>{{ item.appointment_time }}</td>
                </tr>
                </tbody>
                </table>

            <h4 class="mt-3" style="color:black">Prescriptions</h4>
            <table class="table table-sm mt-2" style="color: black;" density="compact">
            <thead><tr><th>Medicine</th><th>Unit</th><th>Price</th></tr></thead>
            <tbody>
              <tr v-for="item in prescriptions" :key="item.id">
                  <td>{{ item.medicine.name }}</td>
                  <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                  <td>{{ item.totalprice }}</td>
              </tr>
            </tbody>
            </table>
            
            <h4 class="mt-3" style="color:black">Payments</h4>
            <table class="table table-sm mt-2" style="color: black;" density="compact">
              <thead><tr><th>Service total</th><th>Prescriptions</th><th>Amount Paid</th><th>Balance</th></tr></thead>
              <tbody>
                <tr v-for="item in payments" :key="item.id">
                    <td>{{ item.services }} </td>
                    <td>{{ item.prescriptions }}</td>
                    <td>{{ item.paid }}</td>                                  
                    <td>{{ item.balance }} </td>                                  
                </tr>
              </tbody>
              </table> -->
            </div>
            <div class="mt-3 text-center">
                <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
                <br> Printed Via Afrimed Software
                <br> www.afrimed.com </p>
            </div>
        </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      visits:[],
      triages:[],
      appointments:[],
      prescriptions:[],
      payments:[],
    };
  },
  created() {
    this.showpatient();
    this.showvisits();
    this.showtriages();
    this.showappointments();
    this.showprescriptions();
    this.showpayments();
  },
  methods: {
    // getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;    

    return `${years} years `;

  } else {
    return `${months} months old`;
  }
},
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    async showpatient(){
      this.patient_id=this.$route.query.id;
      let url = `/patientprofile/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
      });
    },
    async showvisits(){
      // this.patient_id=this.$route.query.id;
      // let url = `/profilevisits/${this.patient_id}`;
      this.visit_id=this.$route.query.visit_id;
      let url = `/insuranceprofilevisits/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.visits = response.data.visits;
      });
    },
    async showtriages(){
      this.patient_id=this.$route.query.id;
      let url = `/profiletriages/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.triages = response.data.triages;
      });
    },
    getPhotos(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"patients/"+name;
            return imagelink;
          },
    async showappointments(){
      this.patient_id=this.$route.query.id;
      let url = `/patientappointment/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.appointments = response.data.appointments;
      });
    },
    async showprescriptions(){
      this.patient_id=this.$route.query.id;
      let url = `/profileprescriptions/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.prescriptions = response.data.prescriptions;
      });
    },
    async showpayments(){
      this.patient_id=this.$route.query.id;
      let url = `/profilepayments/${this.patient_id}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.debts;
      });
    },
  },
  mounted() {
    setTimeout(() => {
        window.print();
        window.onafterprint=this.$router.go(-1);
    }, 5800);
},
};
</script>